import { IconProps } from '.';

function AccordionLine({ color, className }: IconProps) {
  return (
    <svg
      width="100%" height="2"
      viewBox="0 0 915 2"
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <title>AccordionLine</title>
      <path d="M0 0.784668H915" stroke="#CDD3CD" strokeDasharray="2 3" fill={color} />
    </svg>
  );
}

export default AccordionLine;
